import { isLocalhost } from "@faro-lotv/foundation";
import { IReactChildrenOnly } from "@custom-types/types";
import { LocalizeProvider } from "@faro-lotv/foreign-observers";
import { runtimeConfig } from "@src/runtime-config";
import { isNumberedDevEnvironment } from "@utils/env-utils";
import { useLegalRedirect } from "@hooks/use-legal-redirect";
import { Box } from "@mui-wrapper";

/** The localization loader making it possible to implement language translation */
export function LocalizeLoader({ children }: IReactChildrenOnly): JSX.Element {
  const { isLegalRoute } = useLegalRedirect();

  // Dynamically bypass LocalizeProvider if the hook validates this is a legal route
  if (isLegalRoute) {
    return <Box>{children}</Box>;
  }

  const isNumberDevelopmentEnvironment = isNumberedDevEnvironment();

  return (
    <LocalizeProvider
      projectKey={runtimeConfig.features.localizeKey}
      initOptions={{
        // eslint-disable-next-line @typescript-eslint/naming-convention
        saveNewPhrases: !(isLocalhost() || isNumberDevelopmentEnvironment),
      }}
    >
      {children}
    </LocalizeProvider>
  );
}
